import { useState } from "react";

export default function Admission() {
  const [openEdit, setOpenEdit] = useState(false);

  const admission = {
    year: "2023",
    date: "10 June 2023",
    time: "10:45 AM",
    id: "PU9925",
    email: "abhi@gmail.com",
    mobile: "9311132141",
  };

  const downloadPDF = () => {
    window.print(); // simple & effective
  };

  return (
    <div className="card admission-wrapper">

      {/* HEADER */}
      <div className="admission-header">
        <h2>🎓 Admission Details</h2>
        <span className="badge success">Verified</span>
      </div>
      <p className="sub-text">Official university admission record</p>

      {/* DETAILS */}
      <div className="admission-grid">

        <div className="admission-card">
          <span>Admission Year</span>
          <strong>{admission.year}</strong>
        </div>

        <div className="admission-card">
          <span>Admission Date</span>
          <strong>{admission.date}</strong>
        </div>

        <div className="admission-card">
          <span>Admission Time</span>
          <strong>{admission.time}</strong>
        </div>

        <div className="admission-card">
          <span>Student ID</span>
          <strong>{admission.id}</strong>
        </div>

        <div className="admission-card">
          <span>Email ID</span>
          <strong>{admission.email}</strong>
        </div>

        <div className="admission-card">
          <span>Mobile Number</span>
          <strong>{admission.mobile}</strong>
        </div>

      </div>

      {/* ACTIONS */}
      <div className="admission-actions">
        <button className="primary-btn" onClick={() => setOpenEdit(true)}>
          ✏️ Edit (Admin)
        </button>
        <button className="secondary-btn" onClick={downloadPDF}>
          📄 Download PDF
        </button>
      </div>

      {/* ===== ADMISSION ANALYTICS ===== */}
<h3 className="chart-title">📊 Admission Analytics</h3>

<div className="analytics-cards">
  <div className="analytics-card">
    <span>2021 Admissions</span>
    <strong>820</strong>
    <div className="progress">
      <div style={{ width: "65%" }}></div>
    </div>
  </div>

  <div className="analytics-card">
    <span>2022 Admissions</span>
    <strong>1040</strong>
    <div className="progress">
      <div style={{ width: "80%" }}></div>
    </div>
  </div>

  <div className="analytics-card highlight">
    <span>2023 Admissions</span>
    <strong>1320</strong>
    <div className="progress">
      <div style={{ width: "95%" }}></div>
    </div>
  </div>
</div>


      {/* EDIT MODAL */}
      {openEdit && (
        <div className="modal-backdrop">
          <div className="modal">
            <h3>Edit Admission Details</h3>

            <input placeholder="Admission Year" defaultValue="2023" />
            <input placeholder="Admission Date" defaultValue="10 June 2023" />
            <input placeholder="Admission Time" defaultValue="10:45 AM" />
            <input placeholder="Student ID" defaultValue="PU9925" />
            <input placeholder="Email" defaultValue="abhi@gmail.com" />
            <input placeholder="Mobile" defaultValue="9311132141" />

            <div className="modal-actions">
              <button className="primary-btn">Save</button>
              <button
                className="secondary-btn"
                onClick={() => setOpenEdit(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}
